import { Map, fromJS } from 'immutable';

export function request(state, { id }) {
    return state.setIn([ 'items', id, 'unsettlement' ], Map({
        state: 'IN_PROGRESS'
    }));
}

export function error(state, { id, errors }) {
    return state.setIn([ 'items', id, 'unsettlement' ], Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));
}

export function finish(state, { id, selection }) {
    return state
        .setIn([ 'items', id, 'unsettlement' ], Map({
            state: 'FINISHED'
        }));
}
